const AccountIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5.50033 7.5C5.50033 5.01472 7.51504 3 10.0003 3C12.4856 3 14.5003 5.01472 14.5003 7.5C14.5003 9.98528 12.4856 12 10.0003 12C7.51504 12 5.50033 9.98528 5.50033 7.5ZM10.0003 2C6.96276 2 4.50033 4.46243 4.50033 7.5C4.50033 9.60932 5.68773 11.4413 7.43057 12.364C6.71561 12.5707 6.02516 12.8638 5.37507 13.239C3.96871 14.0506 2.80071 15.2181 1.98841 16.6241L1.73828 17.0571L2.60416 17.5573L2.85429 17.1244C3.5788 15.8703 4.62057 14.829 5.87494 14.1051C7.12929 13.3811 8.55206 13 10.0003 13C10.0004 13 10.0004 13 10.0004 13C11.4487 13 12.8715 13.3812 14.1259 14.1051C15.3802 14.8291 16.422 15.8705 17.1464 17.1245L17.3966 17.5575L18.2625 17.0573L18.0123 16.6243C17.2001 15.2183 16.0321 14.0508 14.6257 13.2391C13.9756 12.8638 13.2851 12.5707 12.5701 12.364C14.3129 11.4413 15.5003 9.60932 15.5003 7.5C15.5003 4.46243 13.0379 2 10.0003 2Z"
      fill="currentColor"
    />
  </svg>
);

export { AccountIcon };
